import AddOpportunity from "./AddOpportunity";

export default AddOpportunity;
